import { render, staticRenderFns } from "./ToggleLabel.vue?vue&type=template&id=babc3792&scoped=true&"
import script from "./ToggleLabel.vue?vue&type=script&lang=js&"
export * from "./ToggleLabel.vue?vue&type=script&lang=js&"
import style0 from "./ToggleLabel.vue?vue&type=style&index=0&id=babc3792&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babc3792",
  null
  
)

export default component.exports